module.exports = __webpack_public_path__ + "static/media/Atalanta.ba43349b.png";